/**
 * 解析 url 上的 query 参数，兼容 vue-router hash 模式
 * 支持两种写法（可同时存在）：
 *   1. hash 前面： /?storeType=4/#/product-detail?tenantId=xxx
 *   2. hash 里面： /#/product-detail?tenantId=xxx
 * 两边都有同名参数时，以 hash 里的为准（与 this.$route.query 保持一致）
 */

function parseQuery(str) {
    const result = {}
    // 链接生成方会在 hash 前多带一个 "/"（形如 /?storeType=4/#/xxx，也见 request/apis/store.js），
    // 按 url 规范这个 "/" 会被算进上一个参数的值里（storeType 变成 "4/"）。
    // 它是拼在 query 末尾、紧贴 "#" 的，所以按分隔符处理，只切掉结尾这一个。
    // 不走"把每个值结尾的 / 都裁掉"：那样会连参数值本身的斜杠一起吃掉，且只裁字面量、裁不到 %2F，规则不自洽。
    const queryStr = ((str || '').split('?')[1] || '').replace(/\/+$/, '')
    if (!queryStr) return result
    queryStr.split('&').forEach(item => {
        if (!item) return
        const index = item.indexOf('=')
        const key = index > -1 ? item.slice(0, index) : item
        const value = index > -1 ? item.slice(index + 1) : ''
        if (key) result[key] = value
    })
    return result
}

export function getUrlParams() {
    return {
        ...parseQuery(window.location.search),
        ...parseQuery(window.location.hash)
    }
}

export default getUrlParams


// WEBPACK FOOTER //
// ./src/utils/urlParams.js